import React from 'react';
import { FormFile } from '~/components/FormControl';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
const cx = classNames.bind();

function FileUploaded({ pictureName, formFileClass, setTempUrl, inputEl, children }) {
    return (
        <>
            {children}
            <FormFile
                name={pictureName}
                onChangePicture={(fileObj) => setTempUrl(URL.createObjectURL(fileObj))}
                sm={12}
                className={cx('px-0 ' + formFileClass)}
                ref={inputEl}
            />
        </>
    );
}

const Preview = ({ children }) => {
    return children;
};

FileUploaded.Preview = Preview;

FileUploaded.defaultProps = {
    formFileClass: '',
};
FileUploaded.propTypes = {
    pictureName: PropTypes.string.isRequired,
    formFileClass: PropTypes.string,
    setTempUrl: PropTypes.func.isRequired,
    inputEl: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
};

export default FileUploaded;
